let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gE7hn")).then(() => parcelRequire('c5DUK'));